import {SystemModuleUiSettingsNavigation} from "app/Interface/ApiMapped/System/SystemModuleUi"
import SystemModuleUiService, {SubscribeModuleUiService} from "app/Service/System/Module/SystemModuleUiService"
import WebPathService, {OPERATION_SETTINGS, SubWebPathService} from "app/Service/System/WebPathService"
import Logger from "logger/logger"
import {useNavigate} from "react-router-dom"

function EntitySettingsNavigateService() {

  let navigate = useNavigate()

  const {modulePath, operation, entityId} = WebPathService([
    SubWebPathService.modulePath,
    SubWebPathService.operation,
    SubWebPathService.entityId,
  ], 'EntitySettingsNavigateService')

  const {setSettingsNavigation, activeSystemModuleUi} = SystemModuleUiService([
    SubscribeModuleUiService.active
  ], 'EntitySettingsNavigateService')

  function navigateToSettings(navLink?: string, path?: string, moduleId?: string) {

    const settings: SystemModuleUiSettingsNavigation = {
      navLink,
      from: {
        modulePath,
        operation,
        entityId,
      }
    }

    setSettingsNavigation(settings, moduleId)

    if (path)
      navigate(path)
    else
      navigate(`/${modulePath}/${OPERATION_SETTINGS}`)
  }

  function navigateOutOfSettings() {
    let link = ``
    Logger('EntitySettingsNavigateService.navigateOutOfSettings.activeModuleUi', activeSystemModuleUi)
    if (undefined === activeSystemModuleUi || undefined === activeSystemModuleUi.settings?.from) {
      link = `/${modulePath}`
    } else {
      const {entityId, operation, modulePath: mp} = activeSystemModuleUi.settings.from
      if (entityId) {
        link = `/${mp}/${operation}/${entityId}`
      } else if (operation) {
        link = `/${mp}/${operation}`
      } else if (mp) {
        link = `/${mp}`
      } else {
        throw Error(`Don't know how to navigate out of settings`)
      }
    }
    navigate(link)
  }

  return {
    navigateToSettings,
    navigateOutOfSettings,
  }
}

export default EntitySettingsNavigateService
